document.addEventListener("readystatechange", (event) => {
  if (event.target.readyState === "complete") {
    // Format Phone numbers on pickup drawer
    document
      .querySelectorAll(
        ".location-card-listview-notfullfilment .location-phone"
      )
      .forEach(function (phoneButton) {
        // get the phone number
        var phone = phoneButton.innerText;
        // remove +61 & replace with 0
        phone = phone.replace("+61", "0");
        phone = phone.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2 $3");
        // update the phone number
        phoneButton.innerText = phone;
      });

    // Format Phone numbers on pickup drawer
    document.querySelectorAll(".phone-button").forEach(function (phoneButton) {
      // get the phone number
      var phone = phoneButton.innerText;
      // remove +61 & replace with 0
      phone = phone.replace("+61", "0");
      phone = phone.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2 $3");
      // update the phone number
      phoneButton.innerText = phone;
    });

    document
      .querySelectorAll("span.pickup-available-block")
      .forEach(function (span) {
        if (
          span.parentElement &&
          span.parentElement.tagName.toLowerCase() === "p"
        ) {
          span.parentElement.classList.add("pickup-available-wrapper");
        }
      });
  }
});

jQuery(function ($) {
  $(document).ready(function () {
    $("body").click(function () {
      var productImage = $(
        ".pickup-prod-image-wrapper .pickup-availability-variant-img"
      );
      productImage.attr(
        "src",
        $(".product__media-item.is-active .product__media img").attr("src")
      );
    });
  });
});
